export const FLEET_MODAL_OUTPUTS_OPEN = 'FLEET_MODAL_OUTPUTS_OPEN';

export const FLEET_MODAL_OUTPUTS_GET = 'FLEET_MODAL_OUTPUTS_GET';
export const FLEET_MODAL_OUTPUTS_GET_RESULT = 'FLEET_MODAL_OUTPUTS_GET_RESULT';

export const FLEET_MODAL_OUTPUTS_SAVE = 'FLEET_MODAL_OUTPUTS_SAVE';
export const FLEET_MODAL_OUTPUTS_SAVE_RESULT = 'FLEET_MODAL_OUTPUTS_SAVE_RESULT';